module.exports = __webpack_public_path__ + "static/media/find_spec_1.cb307185.svg";